/* eslint-disable no-magic-numbers */
import { addDays } from 'date-fns'
import { FC, useMemo, useState } from 'react'
// context
import { DateContext } from 'src/modules/core/context/'

const today = new Date()

today.setHours(0, 0, 0, 0)

export const DateProvider: FC = ({ children }) => {
  // state
  const [selectedDate, setSelectedDate] = useState<Date>(today)
  const [daysCount, setDaysCount] = useState<number>(5)

  // memo
  const startDate = useMemo(() => {
    const selectedDateStart = new Date(selectedDate)
    selectedDateStart.setHours(0, 0, 0, 0)

    return addDays(selectedDateStart, -1).getTime()
  }, [selectedDate])

  const endDate = useMemo(() => {
    const selectedDateEnd = new Date(selectedDate)
    selectedDateEnd.setHours(23, 59, 59, 59)

    return addDays(selectedDateEnd, daysCount + 1).getTime()
  }, [daysCount, selectedDate])

  return (
    <DateContext.Provider
      value={{
        selectedDate,
        setSelectedDate,
        setDaysCount,
        startDate,
        endDate,
        daysCount,
      }}
    >
      {children}
    </DateContext.Provider>
  )
}
